import React, { ComponentType, ReactElement } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { getAppContext } from 'src/context/AppContext'

export type CatchErrorProps = {
    renderError?: () => ReactElement
    children: any
}

export const CatchError: ComponentType<CatchErrorProps> = ({
    children,
    renderError = () => null
}) => {
    const {
        error: { handler }
    } = getAppContext()
    return (
        <ErrorBoundary
            FallbackComponent={() => {
                return renderError()
            }}
            onError={err => {
                handler.handle({
                    content: err.toString(),
                    stacktrace: err.stack || ''
                })
            }}
        >
            {children}
        </ErrorBoundary>
    )
}
